/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./myToken.vue?vue&type=template&id=5c282899&scoped=true"
import script from "./myToken.vue?vue&type=script&lang=js"
export * from "./myToken.vue?vue&type=script&lang=js"
import style0 from "./myToken.vue?vue&type=style&index=0&id=5c282899&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c282899",
  null
  
)

export default component.exports